import { Avatar, Card, Icon } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { getAssetUrl } from "@/utils";
import { DetailField } from "../../../common/DetailField";

interface OperatorSectionProps {
  booking: BookingDetails;
}

export const OperatorSection = ({ booking }: OperatorSectionProps) => {
  const { metadata, operator: bookingOperator, driver } = booking;

  const isBookingOffloaded = metadata.isOffloaded || metadata.isOffloadToPrivate || metadata.isOffloadToPublic;
  const isSameOperator = driver?.operator?.providerKey === bookingOperator.providerKey;

  const showOffloadedTo = isBookingOffloaded && !isSameOperator;

  return (
    <div className="space-y-2.5">
      <OperatorFromCard booking={booking} />
      {showOffloadedTo && <OffloadedToCard booking={booking} />}
    </div>
  );
};

const OperatorFromCard = ({ booking }: { booking: BookingDetails }) => {
  const { operator } = booking;

  const OperatorLogo = () => (
    <Avatar src={getAssetUrl(operator.assets.emblem, { height: 24, width: 24, fit: "cover" })} alt={operator.name} size="xs" />
  );

  const ContactLink = ({ phone }: { phone: string }) => (
    <a href={`tel:${phone}`} className="hover:text-info-dark text-base text-info">
      {phone}
    </a>
  );

  return (
    <Card className="space-y-3 p-2.5">
      <DetailField leading={<OperatorLogo />} label="Booking From" value={operator.name} />

      <DetailField
        leading={<Icon name="Call" size="lg" className="text-neutral-dark-gray" />}
        label="Operator Contact Number"
        value={<ContactLink phone={operator.phone} />}
      />
    </Card>
  );
};

const OffloadedToCard = ({ booking }: { booking: BookingDetails }) => {
  const { driver } = booking;

  if (!driver || !driver.operator) return null;

  const { operator } = driver;

  const OperatorLogo = () => (
    <Avatar src={getAssetUrl(operator.assets.emblem, { height: 24, width: 24, fit: "cover" })} alt={operator.name} size="xs" />
  );

  const ContactLink = ({ phone }: { phone: string }) => (
    <a href={`tel:${phone}`} className="hover:text-info-dark text-base text-info">
      {phone}
    </a>
  );

  return (
    <Card className="space-y-3 p-2.5">
      <DetailField leading={<OperatorLogo />} label="Offloaded To" value={operator.name} />

      <DetailField
        leading={<Icon name="Call" size="lg" className="text-neutral-dark-gray" />}
        label="Operator Contact Number"
        value={<ContactLink phone={operator.phone} />}
      />
    </Card>
  );
};
